<template>
  <div class="tarjeta-multimedia multimedia-container-accesibilidad">
    <div class="contenedor-multimedia a11y-ocultar-imagen-link video-none">
      <iframe 
        width='560' 
        height='315' 
        :src='multimedia' 
        title='YouTube video player' 
        frameborder='0' 
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen>
      </iframe>
    </div>
    <div class="a11y-simplificada-block enlace-video">
      <a class="link" :href="multimedia">Ir al video</a>
    </div>
    <div class="multimedia-texto">
      <h5 class="titulo">{{titulo}}</h5>
      <p class="detalles" v-html="detalles"></p>
      <div class="descripcion alto-maximo-simplificado" v-html="texto"></div>
    </div>
    <div class="podcast-bottom">
      <div class="leer-mas">
        <button
          class="boton-leer-mas"
          type="button"
          @click=" $modal.show(identificador)"
        >
          Leer más
        </button>
      </div>

    </div>

    <modal
      :adaptive="true"
      :height="'auto'"
      :scrollable="true"
      :maxWidth="620"
      :width="'90%'"
      class="modal-contenido"
      v-bind:name="identificador"
    >
      <div class="cerrar-modal" @click="$modal.hide(identificador)">&times;</div>
      <div class="contenedor-multimedia a11y-ocultar-imagen-link">
        <iframe 
          width='560' 
          height='315' 
          :src='multimedia' 
          title='YouTube video player' 
          frameborder='0' 
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen>
        </iframe>
      </div>
      <div class="multimedia-texto">
        <p class="detalles-modal" v-html="detalles"></p>
        <div  v-html="texto"></div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "Podcast",
  props: {
    multimedia: {
      type: String,
      default: "iframe",
    },
    titulo: {
      type: String,
      default: "Título del Podcast",
    },
    detalles: {
      type: String,
      default: "Descripción del Podcsast, tres lineas",
    },
    texto: {
      type: String,
      default: " Parrafos y html",
    },
    identificador: {
      type: String,
      default: "id",
    },

  },

};
</script>

<style lang="scss">

.tarjeta-multimedia {
  flex: 1 0 45%; 
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    width: 100%;
    flex: 1 100%;
    }
  height: auto;
  border-radius: 10px;
  box-shadow: 2px 2px 10px #00000029;
  overflow: hidden;
  .contenedor-multimedia{
    width: 100%;
    display: block;
    position: relative;
    iframe{
      position: relative;
      width: 100%;
      height: 250px;
    }
  }

  .podcast-bottom {
    flex-shrink: 0;
  }
  



  .leer-mas {
    padding:  .5 * $gap;
    bottom: calc(12% - #{$gap * 0.5});
    @media (max-width: map-get($media-queries-limit, "mobile")) {
      //display: none;
    }

    .boton-leer-mas {
      border: 1px solid #141414;
      background: white;
      color: #141414;
      font-weight: 500;

      &:hover {
        box-shadow: 2px 2px 10px #00000029;
      }
    }
  }
  .multimedia-texto{
    padding: 0 .5 * $gap;
    .titulo {
      font-size: 20px;
      font-weight: 400;
      margin: .5*$gap 0
    }
    .detalles {
      font-size: 16px;
      font-weight: 600;
      margin: .5*$gap 0 0 0 
    }
    .detalles-modal {
      font-size: 16px;
      font-weight: 600;
      margin: .5*$gap 0 0 0 
    }
    .descripcion {
      max-height: 85px;
      overflow: hidden;
      @media (max-width: map-get($media-queries-limit, "mobile")) {
        max-height: 55px;
      }
      
    }
  }
  .modal-contenido {
    .vm--modal{
      height: auto !important;
      margin-top: 10px;
      margin-bottom: 80px;
      @media (max-width: map-get($media-queries-limit, "mobile")) {
        margin-top: 80px;
        margin-bottom: 80px;    }
    }
    .cerrar-modal {
      position: absolute;
      top: $gap * 0.5;
      right: $gap * 0.5;
      font-size: 50px;
      font-weight: bold;
      z-index: 2;
      text-align: center;
      line-height: 40px;
      color: white;
      width: 40px;
      height: 40px;

      &:hover {
        cursor: pointer;
      }
    }
  }
}








</style>
